import React from 'react';
import moment from 'moment';

// types
import { HistogramData } from 'ducks/merchantDucks/reports/types';

// components
import Loader from 'components/Loader';
import EmptyMessage from 'components/EmptyMessage';
import PieChart from 'pages/MerchantPages/Analytics/components/charts/PieChart';
import Tile from 'pages/MerchantPages/Analytics/components/Tile';
import customLegend from 'components/Legend/CustomLegend';
import { CustomMap } from 'components/StyledMap';
import Choropleth from 'components/Leaflet/Choropleth';
import { Wrapper } from 'pages/MerchantPages/Analytics/Payments/PaymentsTiles';

// functions
import { convertReceivedDataToGeoJSON } from 'utils/convertReceivedDataToGeoJSON';

interface Props {
  startDate: string;
  endDate: string;
  isFetching: boolean;
  data?: HistogramData[];
}

const formatCountryCollection = (data: HistogramData[]) => {
  if (!data) return [];

  return data.map((c: HistogramData) => ({
    country: c.key,
    value: c.doc_count,
  }));
};

const PaymentCharts: React.FC<Props> = ({ startDate, endDate, data = [], isFetching }) => {
  const geojson = convertReceivedDataToGeoJSON(data);
  const PaymentsMap = () => (
    <CustomMap center={[50, 0]} zoom={1} minZoom={1} maxBoundsViscosity={1} attributionControl={false}>
      <Choropleth geoJson={geojson} featureProp="density" mapDescriptionType="Payment" />
    </CustomMap>
  );

  if (isFetching) {
    return <Loader />;
  }

  return (
    <Wrapper>
      <Tile
        title="Payments - Top 10 countries"
        subtitle={`${moment(startDate).format('DD-MM-YYYY')} to ${moment(endDate).format('DD-MM-YYYY')}`}
        tileWidth="100%"
        legend={customLegend('key', '', 'doc_count', data)}
        tileContent={
          <>
            {data && data.length > 0 ? (
              <PaymentsMap />
            ) : (
              <EmptyMessage variant="p">There is no available data for this time period.</EmptyMessage>
            )}
          </>
        }
      />
      <Tile
        title="Payments - Top 10 countries"
        subtitle={`${moment(startDate).format('DD-MM-YYYY')} to ${moment(endDate).format('DD-MM-YYYY')}`}
        tileWidth="100%"
        tileContent={
          <>
            {data && data.length > 0 ? (
              <PieChart data={formatCountryCollection(data)} />
            ) : (
              <EmptyMessage variant="p">There is no available data for this time period.</EmptyMessage>
            )}
          </>
        }
      />
    </Wrapper>
  );
};

export default PaymentCharts;
